import { render, staticRenderFns } from "./main-banner.vue?vue&type=template&id=5865a135&scoped=true&"
import script from "./main-banner.vue?vue&type=script&lang=js&"
export * from "./main-banner.vue?vue&type=script&lang=js&"
import style0 from "./main-banner.vue?vue&type=style&index=0&id=5865a135&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5865a135",
  null
  
)

export default component.exports